var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3 35.1a18 18 0 0 0-7-4.7c-3-.8-5.7 0-8 2.3l-2.9 2.8-.1-.1a40 40 0 0 1-8.4-6.5l-.3-.3a40 40 0 0 1-6.5-8.3V20l2.7-2.8c2.3-2.4 3-5.1 2.2-8a18 18 0 0 0-4.7-7 7.2 7.2 0 0 0-10-.4h-.1A15.6 15.6 0 0 0 1 13.5c0 8 4.4 17 11.6 24.3h.2A45.7 45.7 0 0 0 18 42a1.7 1.7 0 0 0 1.5-3 44 44 0 0 1-4.4-3.7 33.4 33.4 0 0 1-10.7-22 12.3 12.3 0 0 1 3.2-9 3.8 3.8 0 0 1 5.3.2c5.2 5.3 4.8 8 2.5 10.3l-3.7 3.8a1.7 1.7 0 0 0-.3 1.9c2 3.9 4.6 7.5 7.8 10.5l.3.3c3 3.2 6.6 5.8 10.6 7.8a1.7 1.7 0 0 0 1.8-.3l3.7-3.7a4.6 4.6 0 0 1 4-1.5c1.8.2 3.8 1.5 6.3 4a3.8 3.8 0 0 1 .2 5.2 12.3 12.3 0 0 1-8.9 3.3c-3.4-.2-6.7-1-9.8-2.3a1.7 1.7 0 1 0-1.3 3c3.4 1.7 7.2 2.5 11 2.7h.1a15.6 15.6 0 0 0 11.3-4.3h.1V45a7.1 7.1 0 0 0-.4-10h.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.56afa978.svg";
export { ForwardRef as ReactComponent };